import './StudentsList.scss';

import { Tab, Tabs } from '@trackman/web-shared-components';

import ImportStudentListButton from '../ImportStudentListButton/ImportStudentListButton';
import InviteStudentsButton from '../InviteStudentsButton/InviteStudentsButton';
import { Invites } from 'types/organization/invites';
import NoPedingInvitations from '../NoPedingInvitations/NoPedingInvitations';
import NoStudentsFound from '../NoStudentsFound/NoStudentsFound';
import PendingInvites from './PendingInvites/PendingInvites';
import SeeStudents from './SeeStudents/SeeStudents';
import { Students } from 'types/organization/students';
import TableTab from '../TableTab';
import { filterUsersByClass } from 'utilities/organizationDataFilter';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

export const StudentsList = observer(() => {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);
  const [topButtonsVisible, setTopButtonsVisible] = useState(true);
  const ss = useStores().studentsStore;
  const iss = useStores().inviteStudentsStore;
  const cs = useStores().classesStore;

  const handleSelectTabChange = (newValue: number) => {
    setTopButtonsVisible(true);
    setValue(newValue);
    ss.searchInput = '';
    ss.filteredList = filterUsersByClass(ss.students, cs.selectedClassId) as Students;
    iss.searchInput = '';
    iss.filteredList = filterUsersByClass(iss.invites, cs.selectedClassId) as Invites;

    if ((newValue === 0 && !ss.students.length) || (newValue === 1 && !iss.invites.length)) {
      setTopButtonsVisible(false);
    }
  };

  return (
    <>
      <div className='table-tabs-wrapper'>
        <div className='tabs-wrapper'>
          <Tabs value={value} onChange={(event: React.SyntheticEvent, newValue: number) => handleSelectTabChange(newValue)}>
            <Tab label={t('SeeStudents', { ns: 'studentsPage', number: ss.filteredList.length })} />
            <Tab label={t('SeePendingInvites', { ns: 'studentsPage', number: iss.filteredList.length })} />
          </Tabs>
        </div>
        {topButtonsVisible ? (
          <div className='buttons-wrapper'>
            <ImportStudentListButton />
            <InviteStudentsButton />
          </div>
        ) : null}
      </div>
      <TableTab value={value} index={0} tabPrefix='see-students-tab'>
        {!ss.students.length ? <NoStudentsFound /> : <SeeStudents />}
      </TableTab>
      <TableTab value={value} index={1} tabPrefix='pending-invites-tab'>
        {!iss.invites.length ? <NoPedingInvitations /> : <PendingInvites />}
      </TableTab>
    </>
  );
});

export default StudentsList;
